module.exports = __webpack_public_path__ + "static/media/ic_nodust.f00b2bf1.png";